import { detectKoli } from "@/lib/koli";

const uid = () => Math.random().toString(36).slice(2);

// Shared "model block" helpers: lines carry {block, model}; one block per model
export const blankLine = (block = uid(), model = "") => ({ id: uid(), block, model, product_id: "", sizes: {}, koli_type_id: "", koli_count: "" });

export const groupBlocks = (lines) => [...new Set(lines.map((l) => l.block))].map((b) => lines.filter((l) => l.block === b));

// For each block: the models already taken by the other blocks
export const usedByOthers = (blocks, key = "model") => blocks.map((bl) => blocks.filter((o) => o !== bl).map((o) => o[0][key]));

export const blockActions = (setLines, products) => ({
  setModel: (block, model) => setLines((prev) => {
    const at = prev.findIndex((l) => l.block === block);
    const rest = prev.filter((l) => l.block !== block);
    const fresh = blankLine(block, model);
    const colors = products.filter((p) => p.model_code === model);
    if (colors.length === 1) fresh.product_id = colors[0].id;
    rest.splice(at, 0, fresh);
    return rest;
  }),
  addColor: (block, model) => setLines((prev) => {
    const last = prev.map((l) => l.block).lastIndexOf(block);
    const next = [...prev]; next.splice(last + 1, 0, blankLine(block, model)); return next;
  }),
  removeBlock: (block) => setLines((prev) => prev.filter((l) => l.block !== block)),
  removeLine: (id) => setLines((prev) => prev.filter((l) => l.id !== id)),
});

// product_id+sizes list -> block lines grouped by model
export const toBlockLines = (items, productById, koliTypes = []) => items.map(({ product_id, sizes }) => {
  const model = productById(product_id)?.model_code || "";
  return { ...blankLine(`m-${model}`, model), product_id, sizes, ...detectKoli(sizes, koliTypes) };
});
